import React, { Component } from "react";
import {
    NavBar,
    Icon,
    List,
    Drawer,
    WhiteSpace,
    InputItem,
    Button,
    WingBlank,
    Pagination,
    Toast,
    SearchBar,
    Picker,
} from "antd-mobile";
import "./transferUsersRecord.scss";
import axios from "../../../service/axios";
import NoneDatas from "../../../components/noneDatas";
import { createForm } from "rc-form";
import moment from "moment";
const Item = List.Item;
const Brief = Item.Brief;
const selectedContainer = {
    position: "fixed",
    width: "100%",
    top: "45px",
    background: "#f5f5f5",
    height: "100%",
    zIndex: "11",
    transition: "left 0.4s",
};
export class TransferUsersRecord extends Component {
    state = {
        open: false,
        transferUsersRecordList: [],
        pageTotalNum: 0,
        pageNo: 1,
        showCheck: false,
        drawerSearch: document.body.clientWidth,
        paramsSearch: {},
    };
    componentDidMount() {
        this.getTransferUsersRecordList(1);
    }
    getTransferUsersRecordList(e) {
        axios.post("/api/log/user/transfer/list", {
            page: {
                pageNo: e,
                pageSize: 10,
            },
            ...this.state.paramsSearch,
        }).then(res => {
            if (res.status == 200) {
                this.setState({
                    transferUsersRecordList: res.data.resultList || [],
                    pageNo: e,
                    pageTotalNum: Math.ceil(res.data.totalCount / 10),
                });
            } else {
                Toast.fail(res.message);
            }
        });
    }
    onOpenChange = () => {
        this.setState({
            open: !this.state.open,
        });
    };
    onPageChange = e => {
        const { pageTotalNum } = this.state;
        e = e > pageTotalNum ? pageTotalNum : e;
        this.getTransferUsersRecordList(e);
    };
    //搜索
    searchList() {
        this.props.form.validateFields({ force: true }, error => {
            if (!error) {
                console.log(this.props.form.getFieldsValue());
                const fieldsValue = this.props.form.getFieldsValue();
                this.setState({
                    paramsSearch: {
                        ...fieldsValue
                    },
                    drawerSearch: document.body.clientWidth,
                });
                setTimeout(() => {
                    this.getTransferUsersRecordList(1);
                }, 0);
            }
        });
    };
    searchAllList() {
        this.setState({
            paramsSearch: {},
            drawerSearch: document.body.clientWidth,
        });
        setTimeout(() => {
            this.getTransferUsersRecordList(1);
        }, 0);
    };

    render() {
        const { getFieldProps, getFieldError } = this.props.form;
        const { showCheck, drawerSearch, } = this.state
        const sidebar = (
            <div className="currency-record-sidebar">
                <List renderHeader={() => "搜索操作信息"}>
                    <InputItem clear placeholder="操作类型">
                        操作类型
                    </InputItem>
                    <WhiteSpace size="xl" />
                    <Button type="primary">搜索</Button>
                    <WhiteSpace size="xl" />
                    <Button onClick={this.onOpenChange} type="">
                        关闭
                    </Button>
                </List>
            </div>
        );
        const { transferUsersRecordList, pageTotalNum, pageNo } = this.state;
        return (
            <div className="transferUsersRecord">
                <div className="header-sticky">
                    <NavBar
                        icon={<Icon type="left" />}
                        onLeftClick={() => this.props.history.goBack()}
                        rightContent={[
                            showCheck ? (
                                <Icon
                                    onClick={() => {
                                        this.setState({
                                            showCheck: false,
                                            selectItem: [],
                                        });
                                    }}
                                    key="1"
                                    type="cross"
                                />
                            ) : (
                                    <Icon
                                        type="search"
                                        size="sm"
                                        key="1"
                                        onClick={() =>
                                            this.setState({
                                                drawerSearch: 0,
                                            })
                                        }
                                    />
                                ),
                        ]}
                    >
                        用户迁移记录
                    </NavBar>
                </div>
                <div className="sub-container">
                    <List>
                        {transferUsersRecordList.map((i, index) => (
                            <Item
                                key={index}
                                arrow="horizontal"
                                multipleLine
                                onClick={() => { }}
                            >
                                迁移对象： {i.toId}
                                <Brief>迁移者：{i.fromId}</Brief>
                                <Brief>账号：{i.account}</Brief>
                                <Brief>
                                    创建时间：{moment(i.createTime).format('YYYY-MM-DD HH:mm:ss')}
                                </Brief>
                            </Item>
                        ))}
                    </List>
                    {transferUsersRecordList.length == 0 ? <NoneDatas /> : ""}
                    <WhiteSpace size="xl" />
                    <WingBlank>
                        <SearchBar
                            placeholder="请输入跳转页面"
                            onSubmit={value => this.onPageChange(value)}
                        />
                    </WingBlank>
                    <WhiteSpace size="xl" />
                    <WingBlank>
                        {pageTotalNum > 0 ? (
                            <Pagination
                                total={pageTotalNum}
                                current={pageNo}
                                locale={{
                                    prevText: "上一页",
                                    nextText: "下一页",
                                }}
                                onChange={e => this.onPageChange(e)}
                            />
                        ) : (
                                ""
                            )}
                    </WingBlank>
                    <div style={{ ...selectedContainer, left: drawerSearch }}>
                        <div className="transfer-users-record-sidebar">
                            <List
                                renderHeader={() => "搜索用户迁移记录"}
                            >
                                <InputItem
                                    {...getFieldProps("srcsvr")}
                                    clear
                                    placeholder="请输入迁移者"
                                >
                                    迁移者
                                </InputItem>
                                <InputItem
                                    {...getFieldProps("destsvr")}
                                    clear
                                    placeholder="请输入迁移对象"
                                >
                                    迁移对象
                                </InputItem>
                                <InputItem
                                    {...getFieldProps("loginName")}
                                    clear
                                    placeholder="请输入账号"
                                >
                                    账号
                                </InputItem>
                            </List>
                            <WhiteSpace size="xl" />
                            <Button type="primary" onClick={() => this.searchList()}>
                                搜索
                            </Button>
                            <WhiteSpace size="xl" />
                            <Button type="primary" onClick={() => this.searchAllList()}>
                                全部
                            </Button>
                            <WhiteSpace size="xl" />
                            <Button
                                onClick={() => {
                                    this.setState({
                                        drawerSearch: document.body.clientWidth,
                                    });
                                }}
                                type=""
                            >
                                关闭
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default createForm()(TransferUsersRecord);
